module.exports = __webpack_public_path__ + "img/replay.d876b895.png";